export const NAME = 'subtopics';
export const LEVEL_ONE = 'SubtopicsComponentReducer';
